import {useSelector} from 'react-redux';

import BadgesGrid from '@/components/BadgesGrid/BadgesGrid';
import useBadgeDetailRoute from '@/hooks/useBadgeDetailRoute';
import {selectAllBadges} from '@/state/selectors/loyalty';

const BadgesCollectionSection = () => {
    const badges = useSelector(selectAllBadges);
    const {openBadge} = useBadgeDetailRoute();

    if (!badges.length) return null;

    return <BadgesGrid className='px-4' badges={badges} onBadgeClick={openBadge} />;
};

export default BadgesCollectionSection;
